import React, { useEffect, useState } from "react";

import styles from "./dialog.module.scss";
import { ButtonBox } from "../button/Button";
import Icon from "../icons/Icon";
import { Xg900 } from "../icons/18";

const TooltipB = ({
  isShow = true,
  title,
  content,
  direction = "bottom",
  pointerLocation = "center",
  extra,
  marginForCustom = "",
  zIndex = "",
  close,
  widthValue = { width: "", maxWidth: "", minWidth: "" },
}: {
  isShow?: boolean;
  title?: string;
  content?: string;
  direction?: "top" | "bottom";
  pointerLocation?: "left" | "center" | "right";
  extra?: React.ReactNode;
  marginForCustom?: string; //margin 값으로 위치 조정 필요한 경우 사용
  zIndex?: number | string; // zIndex 조정 없으면 헤더 zIndex - 1
  close?: () => void;
  widthValue?: { width: string; maxWidth: string; minWidth: string };
}) => {
  const [toolTipShow, setToolTipShow] = useState(false);
  useEffect(() => {
    if ((content || title || extra) && isShow) {
      setToolTipShow(true);
    }
  }, [content, isShow]);

  return (
    isShow &&
    toolTipShow && (
      <div
        className={`${styles["dialog"]} ${styles["dialog--tooltip-b"]} ${styles[`dir-${direction}`]} ${styles[`pointer-${pointerLocation}`]}`}
        style={{
          margin: marginForCustom,
          zIndex: zIndex,
        }}
      >
        <div
          className={`${styles["tooltip-wrap"]}`}
          style={{
            width: widthValue.width,
            maxWidth: widthValue.maxWidth,
            minWidth: widthValue.minWidth,
          }}
        >
          <div className={styles["tooltip-content-wrap"]}>
            {title && (
              <div className={styles["tooltip-title"]}>
                <h3>{title}</h3>
                {close && (
                  <ButtonBox
                    className={styles["tooltip-close"]}
                    type="icon"
                    onClick={() => {
                      close();
                      setToolTipShow(false);
                    }}
                  >
                    <Icon IconComponent={<Xg900 />} size={18} />
                  </ButtonBox>
                )}
              </div>
            )}
            <div className={styles["tooltip-content"]}>
              {content && <p>{content}</p>}
              {extra && extra}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default TooltipB;
